import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from './AdminGrid';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function OrgUsersTab({ orgId }) {
  const columns = useMemo(() => [
    { field: 'firstName', headerName: 'First Name' },
    { field: 'lastName', headerName: 'Last Name' },
    { field: 'email', headerName: 'Email', minWidth: 200 },
    { field: 'role', headerName: 'Role' },
    { field: 'lastLogin', headerName: 'Last Login', valueFormatter: fmtDate },
    { field: 'createdAt', headerName: 'Created', valueFormatter: fmtDate },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getOrgUsers(orgId, 0, 10000);
    return res.content || [];
  }, [orgId]);

  return <AdminGrid columns={columns} fetchData={fetchData} />;
}
